/**
 * Created by jax.luo on 2016/9/26.
 */
angular.module('dpw.services')
    .factory('dpwStorage', ['$window', function ($window) {
        'use strict';

        var storage = {};

        if (!isLocalStorageSupported()) {
            Object.defineProperty(storage, "length", {
                get: function () {
                    return Object.keys($.cookie()).length;
                }
            });

            storage.key = function (n) {
                throwMethodError("key", 1, arguments.length);

                var idx = parseInt(n, 10);
                if (isNaN(idx)) {
                    return null;
                }
                return Object.keys($.cookie())[idx] || null;
            };

            storage.getItem = function (key) {
                throwMethodError("getItem", 1, arguments.length);
                return $.cookie(key) || null;
            };

            storage.setItem = function (key, value, saveCookieIfNotSupport) {
                throwMethodError("setItem", 2, arguments.length);
                if (saveCookieIfNotSupport !== false) {
                    $.cookie(key, value, {expires: 365, path: '/'});
                }
            };

            storage.removeItem = function (key) {
                throwMethodError("removeItem", 1, arguments.length);

                $.removeCookie(key);
            };
        }
        else {
            storage = $window.localStorage;
        }

        return storage;

        function throwMethodError(methodName, requiredParaCount, actualParaCount) {
            if (actualParaCount < requiredParaCount) {
                throw new TypeError("Failed to execute '" + methodName + "' on 'Storage': " + requiredParaCount + " argument required, but only " + actualParaCount + " present.");
            }
        }

        function isLocalStorageSupported() {
            var testKey = 'isLocalStorageSupported', storage = $window.localStorage;
            try {
                storage.setItem(testKey, '1');
                storage.removeItem(testKey);
                return true;
            }
            catch (error) {
                return false;
            }
        }

    }]);